import { useQuery } from '@apollo/client/react';
import { uniqBy } from 'lodash-es';
import { useEffect, useState } from 'react';

import { useQueryErrorToast } from './useQueryErrorToast';
import { Gift } from '../libs';
import { GraphQLClient, LIST_GIFTS_QUERY } from '../libs/graphQL';

type ListGiftsData = { listGifts: { data: Gift[]; next?: string } };

const useListSpecialRequest = (filters: any, next?: string) => {
  const [specialRequestList, setSpecialRequest] = useState<any>([]);
  const [newNext, setNewNext] = useState<string | undefined>(next);
  const limit = 200;
  const { data, error, loading, refetch, fetchMore } = useQuery<ListGiftsData>(LIST_GIFTS_QUERY, {
    variables: {
      query: {
        filters: {
          kitchen: filters.kitchen,
          date: filters.date
        },
        limit
      }
    }
  });

  useEffect(() => {
    if (data?.listGifts?.data) {
      setSpecialRequest(data?.listGifts?.data);
    }
    if (data?.listGifts?.next) {
      setNewNext(data?.listGifts?.next);
    }
  }, [data]);

  useQueryErrorToast(error);

  const handleFetchMore = () => {
    if (newNext) {
      void fetchMore({
        variables: {
          query: {
            filters: {
              kitchen: filters.kitchen,
              date: filters.date
            },
            limit,
            cursor: newNext
          }
        },
        updateQuery: (prev: any, { fetchMoreResult }) => {
          if (!fetchMoreResult) return prev;
          if (prev) {
            setNewNext(fetchMoreResult?.listGifts?.next || undefined);
            const prevGifts = Array.isArray(prev?.listGifts?.data) ? prev.listGifts.data : [];
            const newGiftsData = Array.isArray(fetchMoreResult?.listGifts?.data) ? fetchMoreResult.listGifts.data : [];
            const newGifts = uniqBy([...prevGifts, ...newGiftsData], 'id');
            return {
              ...prev,
              listGifts: {
                ...prev.listGifts,
                data: newGifts,
                next: fetchMoreResult?.listGifts?.next
              }
            };
          }

          return prev;
        }
      });
    }
  };

  const clearData = () => {
    setSpecialRequest([]);

    setNewNext(undefined);
    void GraphQLClient.clearStore();
  };

  return {
    isLoading: loading,
    specialRequestList: specialRequestList as Gift[],
    refetchRequest: refetch,
    hasNext: Boolean(newNext),
    clearRequestData: clearData,
    handleFetchMoreRequest: handleFetchMore
  };
};

export default useListSpecialRequest;
